import React, { useContext } from 'react'
import { HStack, Box, RadioGroup, RadioButton } from '@postenbring/hedwig-react'
import { InternationalCalculatorContext } from '../../InternationalCalculatorContext'

export const ServiceTypeSelector = ({ labels }) => {
  const { serviceType, setService } = useContext(InternationalCalculatorContext)

  const services = [
    { value: 'PICKUP_PARCEL', label: labels.pickupParcel },
    { value: 'BUSINESS_PARCEL', label: labels.businessParcel },
  ]

  return (
    <RadioGroup
      name="serviceType"
      onChange={(e) => setService(e.target.value)}
      value={serviceType}
    >
      <HStack gap="12">
        {services.map((s) => (
          <div key={s.value} style={{ flex: 1 }}>
            <Box
              variant="white"
              style={{
                padding: "16px",
                border: serviceType === s.value ? "2px solid #00643A" : "2px solid transparent",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <RadioButton value={s.value} checked={serviceType === s.value}>
                {s.label}
              </RadioButton>
            </Box>
          </div>
        ))}
      </HStack>
    </RadioGroup>
  )
}